﻿﻿export interface IDonorSurgeon {
    id: number;
    fullName: string;
    centerAlias: string;
    count: number;
    issueCount: number;
    issueRate: number;
}
